import React from 'react';

export default function LoadingAppBusy(props:any) {


    const label = (props.label)?props.label:'Please wait';

    const topHeight = gd.layout.top.height+'px';

    const topStyles = {
        height: topHeight
    };

    const mainStyles = {
        height: 'calc(100% - '+topHeight+')',
        top: topHeight
    };

    const onTopOverlayClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();
        e.preventDefault();
    };

    return (
        <div className="ui-loading app-busy" style={mainStyles}>

            <div className="top-overlay" onClick={onTopOverlayClick} style={topStyles}></div>

            <div className="gd-loading main-area" >
                <div className="loading-block">
                    <img className="loading-image" src="/app/web/skin/common/loader/app-loading.gif" />
                    <div className="loading-label">{label}</div>
                </div>
            </div>
        </div>
    );


}
